import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonPage,
  IonRow,
  IonText,
  IonToast,
} from "@ionic/react";
import { useState } from "react";
import { signUp } from "../../genericFunctions/signUp";
import { paramsSingup } from "../../types/types";
import "../IonColor/color.css";
import LogoLogin from "../Login/LogoLogin";
import LogoQualiopi from "../Login/LogoQualiopi";
import TechnoListButton from "../TechnoListButton/TechnoListButton";
import ItemRegister from "./ItemRegister";
import "./Register.css";
import registerItems from "./registerInterface";

interface ContainerProps {
  pathLogo: string;
}

const RegisterFORMACEO: React.FC<ContainerProps> = ({ pathLogo }) => {
  const [showToast, setShowToast] = useState<boolean>(false);
  const [message, setMessage] = useState<string | undefined>("none");
  const urlParams = new URLSearchParams(window.location.search);

  const handleRegister = async () => {
    if (registerItems.filter((r) => !r.isValid).length === 0) {
      const params: paramsSingup = {
        last_name: registerItems[0].value ?? "",
        first_name: registerItems[1].value ?? "",
        email: registerItems[2].value ?? "",
        phone_number: registerItems[3].value ?? "",
        password: registerItems[4].value ?? "",
        duration: Number.parseInt(registerItems[6].value ?? "6"),
        premium: urlParams.get("premium") ? true : false,
      };
      await signUp(params, setMessage).catch((e) => {
        setMessage("erreur : " + e.response.data.error);
        setShowToast(true);
      });
    } else {
      setMessage("erreur : Veuillez vérifiez l'intégrité de vos données");
      setShowToast(true);
    }
  };

  return (
    <IonPage className="register">
      {/* Displaying error on login */}
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={message}
        position="middle"
        color="danger"
        duration={2000}
      />
      {/* End of dislplaying error on login */}

      {/* Display REGISTER */}
      <IonContent color="primary">
        <IonGrid>
          <LogoLogin path={pathLogo} />
          <IonRow className="ion-justify-content-center">
            <IonCol size-lg="5" size-sm="10">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleRegister();
                }}
              >
                <IonRow className="ion-justify-content-center">
                  <IonText color="black" className="ion-text-center">
                    <h1>Connexion</h1>
                    <h5>Veuillez entrer vos informations</h5>
                  </IonText>
                </IonRow>
                {registerItems.map((item, i, arr) => {
                  const index = i;
                  return (
                    <ItemRegister
                      item={item}
                      index={index}
                      items={arr}
                      key={i}
                    />
                  );
                })}

                <IonRow
                  className="ion-justify-content-center"
                  style={{
                    alignItems: "stretch",
                  }}
                >
                  <IonCol size="12" size-sm="12" size-lg="6">
                    <button
                      type="submit"
                      style={{
                        width: "100%",
                        background: "transparent",
                      }}
                    >
                      <IonButton
                        color="secondary"
                        shape="round"
                        expand="full"
                      >
                        Créez votre compte
                      </IonButton>
                    </button>
                  </IonCol>

                  <IonCol size="12" size-sm="12" size-lg="6">
                    <IonButton
                      color="tertiary"
                      expand="full"
                      shape="round"
                      onClick={() => {
                        window.location.href =
                          "/?" +
                          (new URLSearchParams(window.location.search).get(
                            "premium"
                          ) !== null
                            ? "premium=true"
                            : "");
                      }}
                    >
                      Déjà un compte
                    </IonButton>
                  </IonCol>
                </IonRow>
                <TechnoListButton />
              </form>
            </IonCol>
          </IonRow>
          <LogoQualiopi />
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default RegisterFORMACEO;
